import React, { FC, useContext, useEffect, useState } from 'react';

import { Separator, Toggle } from '@smartshell/ui-kit';

import { PercentInput, SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import { openConfirmDialog } from '../../../../../../../../../services/Confirmation';
import s from './BonusSystem.module.scss';

export const BonusSystem: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('smart_bonus');

  const {
    state: { settings },
    actions: { setSetting, setSettings },
  } = useContext(SettingsContext);

  const [, setCategory] = useState<Array<string> | null>(null);
  // const [openActiveBonusModal, setOpenActiveBonusModal] =
  //   useState<boolean>(false);

  useEffect(() => {
    if (settings) {
      const enabledCategories = [
        settings.holidayTariffsEnabled ? 'TARIFFS_ENABLED' : null,
        settings.bonusGoodsEnabled ? 'BONUS_GOODS_ENABLED' : null,
        settings.bonusServicesEnabled ? 'BONUS_SERVICES_ENABLED' : null,
      ].filter(Boolean) as string[];

      setCategory(enabledCategories);
    }
  }, [settings]);

  return (
    <>
      {!settings.isBonusSystemEnabled && (
        <>
          <Toggle
            onChange={(value: string) =>
              openConfirmDialog(t, 'confirm', {
                title: t('settings.bonus.system.modal'),
                message: t('settings.bonus.system.modal.description'),
                acceptTitle: t('activate'),
                declineTitle: t('cancel'),
              }).then(({ status }) => {
                if (status === 'ACCEPTED') {
                  setSetting({
                    alias: ESettingsAliases.BONUS_SYSTEM_ENABLED,
                    value: value ? '1' : '0',
                  });
                }
              })
            }
            value={settings.isBonusSystemEnabled}
            label={t('setting.bonuses')}
            description={t('settings.billing.system.bonus.description')}
            variant="secondary"
            emptyBg
            disabled={!isAvailable || settings.isBonusSystemEnabled}
            rightContent={!isAvailable ? <SettingsLock /> : undefined}
            disabledTooltip={t('settings.bonus.system.tooltip')}
          />

          <Separator className={s.separator} />
        </>
      )}

      <Toggle
        onChange={(value: boolean) =>
          value
            ? setSettings([
                {
                  alias: ESettingsAliases.DEPOSIT_REFILL_ENABLED,
                  value: '1',
                },
                {
                  alias: ESettingsAliases.TARIFFS_ENABLED,
                  value: '1',
                },
              ])
            : setSetting({
                alias: ESettingsAliases.DEPOSIT_REFILL_ENABLED,
                value: '0',
              })
        }
        value={settings.isDepositRefillEnabled}
        label={t('setting.bonuses.deposit_refill_enabled.title')}
        variant="secondary"
        emptyBg
        disabled={!isAvailable}
      />

      <Separator className={s.separator} />

      <Toggle
        label={t('setting.bonuses.tariffs')}
        value={settings.isBonusPaymentTariffsEnabled}
        onChange={(value: string) => {
          setSetting({
            alias: ESettingsAliases.TARIFFS_ENABLED,
            value: value ? '1' : '0',
          });
        }}
        variant="secondary"
        emptyBg
        disabled={
          settings.isDepositRefillEnabled || !settings.isBonusSystemEnabled
        }
      />

      <Separator className={s.separator} />

      {/*<MultiSelect*/}
      {/*  title="Категории"*/}
      {/*  className={s.multiselect}*/}
      {/*  name=""*/}
      {/*  options={[*/}
      {/*    { title: 'Тарифы', value: 'TARIFFS_ENABLED', disabled: true },*/}
      {/*    { title: 'Товары', value: 'BONUS_GOODS_ENABLED' },*/}
      {/*    { title: 'Услуги', value: 'BONUS_SERVICES_ENABLED' },*/}
      {/*  ]}*/}
      {/*  value={category?.length ? category : null}*/}
      {/*  onChange={(selectedValues) => {*/}
      {/*    const currentCategories = category ?? [];*/}

      {/*    selectedValues?.forEach((value) => {*/}
      {/*      const settingAlias =*/}
      {/*        ESettingsAliases[value as keyof typeof ESettingsAliases];*/}

      {/*      if (!currentCategories.includes(value)) {*/}
      {/*        setSetting({ alias: settingAlias, value: '1' });*/}
      {/*        setCategory([...currentCategories, value]);*/}
      {/*      }*/}
      {/*    });*/}

      {/*    currentCategories.forEach((value) => {*/}
      {/*      if (!selectedValues?.includes(value)) {*/}
      {/*        const settingAlias =*/}
      {/*          ESettingsAliases[value as keyof typeof ESettingsAliases];*/}
      {/*        setSetting({ alias: settingAlias, value: '0' });*/}
      {/*        setCategory(currentCategories.filter((v) => v !== value));*/}
      {/*      }*/}
      {/*    });*/}
      {/*  }}*/}
      {/*  disabled={isAvailable}*/}
      {/*  variant="secondary"*/}
      {/*/>*/}

      <PercentInput
        label={t('settings.billing.system.percent.title')}
        description={t('settings.billing.system.percent.description')}
        setting={settings.isUsagePercent}
        updateSetting={setSetting}
        settingAlias={ESettingsAliases.USAGE_PERCENT}
        minPercent={0}
        maxPercent={100}
        disabled={!isAvailable || !settings.isBonusSystemEnabled}
      />

      {settings.isUsagePercent === 100 && isAvailable && (
        <>
          <Separator className={s.separator} />

          <Toggle
            label={t('settings.billing.system.balance.title')}
            description={t('settings.billing.system.balance.description')}
            value={settings.isUseDepositFirstEnabled}
            onChange={(value: string) =>
              setSetting({
                alias: ESettingsAliases.USE_DEPOSIT_FIRST_ENABLED,
                value: value ? '1' : '0',
              })
            }
            variant="secondary"
            emptyBg
            disabled={
              !isAvailable ||
              settings.isUsagePercent !== 100 ||
              !settings.isBonusSystemEnabled
            }
          />
        </>
      )}
    </>
  );
};
